<div class="container">
  <div class="modal-header">
    <div>
      <span class="header">Device specs for {{ data.deviceName }}</span>
    </div>
  </div>
  <div class="content" *ngIf="dialogData.length">
    <ul *ngFor="let item of dialogData">
      <h4 class="cap-label">{{ item.title }}</h4>
      <li *ngFor="let list of item.info" class="list">
        <div
          class="portLabel"
          [ngClass]="{'up-space': list.key.includes(this.port2)}"
          *ngIf="list.key.includes(this.port1) || list.key.includes(this.port2)"
        >
          {{ list.key }}
        </div>
        <div class="key" *ngIf="!list.key.includes(this.port1) && !list.key.includes(this.port2)">
          {{ list.key }}
        </div>
        <div class="value" *ngIf="list.key !== 'codecs'">
          {{ list.value }}
        </div>
        <div class="value" *ngIf="list.key == 'codecs'">
          <span *ngFor="let codec of list.value">
            <div>{{ codec.name }} - {{ codec.value }}</div>
          </span>
        </div>
      </li>
    </ul>
  </div>

  <div class="close">
    <button mat-flat-button [mat-dialog-close]="true">DONE</button>
  </div>
</div>
